import { capitalize } from '@chainflip/utils/string';
import { getRuntimeVersionQuery } from '@/shared/graphql/cache/environment';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import { getChainflipNetwork } from '@/shared/utils/env';
import { formatRuntimeVersion } from '@/shared/utils/strings';

export default function useNetworkInfo() {
  const { data } = useGqlQuery(getRuntimeVersionQuery, {
    context: { clientName: 'statechainCache' },
  });

  const version = data?.allEnvironmentAddresses?.nodes[0].runtimeVersion;

  if (!version) return capitalize(getChainflipNetwork());

  return `${capitalize(getChainflipNetwork())} ${formatRuntimeVersion(version)}`;
}
